<template>
  <div v-show="this.events.length > 0" class="bg-white mb-5">
    <h2 
      class="text-center uppercase font-medium leading-tight"
      :class="{'mb-5': campaignViewType === 'Refreshed', 'mb-3': campaignViewType !== 'Refreshed'}"
      >Our Events</h2>

    <div v-for="myEvent in events">
      <div v-if="campaignViewType === 'Refreshed'" class="flex items-center bg-gray-100 rounded-full mb-4 pr-8 w-64 mx-auto py-3">
        <div class="bg-pink-500 text-white rounded-full min-w-[90px] min-h-[90px] max-h-[90px] max-w-[90px] flex flex-col items-center justify-center">
          <p class="font-custom font-bold tracking-widest my-0 leading-none text-2xl uppercase">{{myEvent.beginMonth}}</p>
          <p class="font-custom font-bold leading-none my-0 leading-none text-4xl mt-[-3px]">{{myEvent.beginDay}}</p>
          <p class="font-custom-light font-light my-0 leading-none text-sm">{{myEvent.timeRange}}</p>
        </div>
        <div class="ml-4 flex flex-col">
          <p class="text-custom-pill font-medium text-2xl leading-5 mb-2">{{myEvent.title}}</p>
          <div class="flex items-center">
            <i class="fas fa-map-marker-alt text-pink-500"></i>
            <a :href="myEvent.googleMapUrl" target="_blank" class="text-link ml-1 leading-none text-sm underline">{{ myEvent.city }}, {{ myEvent.state }}</a>
          </div>
        </div>
      </div>

      <div v-else class="border-b py-3 flex items-center">
        <div class="flex items-start justify-center w-1/6 px-0">
          <div>
            <div class="flex justify-center items-center flex-col">
              <div class="mb-0 mr-2 text-blue font-medium block text-4xl block">{{myEvent.beginDay}}</div>
              <div class="mb-0 mr-2 text-blue font-normal block uppercase text-base block">{{myEvent.beginMonth}}</div>
            </div>
          </div>
        </div>
        <div class="pl-3">
          <div class="flex flex-col space-y-1">
            <span class="text-sm text-black font-medium">{{myEvent.title}}</span>
            <div class="flex flex-row items-center">
              <span class="mb-0 mr-1">
                <i class="fas fa-clock text-gray-600 text-sm"></i>
              </span>
              <span class="mb-0 relative text-sm">{{myEvent.timeRange}}</span>
            </div>
            <div class="flex flex-row">
              <span class="mb-1 mr-1">
                <i class="fas fa-map-marker text-gray-600 text-sm"></i>
              </span>
              <span class="mb-0 relative text-sm">
                <a class="text-pink hover:text-pink-600" :href="myEvent.googleMapUrl" target="_blank">
                  {{myEvent.city}}, {{myEvent.state}} {{myEvent.zip}}
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CampaignEventDisplay',
    props: {
      campaignId: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        events: [],
      }
    },
    created() {
      axios.get(`/campaign/${this.campaignId}/events`)
          .then(response => {
            this.events = response.data
          })
          .catch(error => {
            console.error('Error fetching campaign events:', error);
          });
    },
    computed: {
      campaignViewType() {
        return this.$store.state.campaignWidget.campaignViewType;
      }
    },
  }
</script>

<style>
.font-custom {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 700;
}
.font-custom-light {
  font-family: "Barlow Condensed", sans-serif;
  font-weight: 300;
}
.text-custom-pill {
  font-family: "Barlow Condensed", sans-serif;
  font-weight: 500;
}
.text-link {
  font-family: "Barlow Condensed", sans-serif;
  font-weight: 400;
  text-decoration-line: underline;
  color: #DA1884;
}
</style>
